import {Component, ElementRef, Input, ViewChild} from '@angular/core';
import {ExcCoreModule, ExcTranslation} from 'exc-core-v2';

@Component({
  selector: 'app-commentary-box',
  templateUrl: './commentary-box.component.html',
  styles: [
  ]
})
export class CommentaryBoxComponent extends ExcTranslation {
  @ViewChild('VCCommText', {read: ElementRef}) VCCommText!: ElementRef;

  @Input()
  set checkview(inputObj: any) {
    this._checkview = inputObj;
    this.init();
    this.ready();
  }
  get checkview(): any {
    return this._checkview;
  }
  set commListGrouped(inputObj: any) {
    this._commListGrouped =  inputObj;
  }
  get commListGrouped(): any {
    return this._commListGrouped;
  }
  set commList(inputObj: any) {
    this._commList = inputObj;
  }
  get commList(): any {
    return this._commList;
  }
  state = 1;
  isLoading = true;
  _checkview: any;
  _commList: any;
  _commListGrouped: any;

  ready = () => {
    this.isLoading = false;
    if (this.tableEmpty) {
      this.state = 2;
    } else {
      this.state = 0;
    }
  }

  constructor() {
    super();
  }

  getDateCompare(date: any): string {
    const dt = new Date(date);
    return dt.getFullYear() + '' + (dt.getMonth() + 1) + '' + dt.getDate();
  }

  filteredDataList = (date: { commCRD_Date: Date }): any[] => {
    return ExcCoreModule.Array.GetAll(
      this.commList,
      'commCRD_Date',
      date.commCRD_Date);
  }

  get tableEmpty(): boolean {
    return (!this.commList || (this.commList && this.commList.length === 0))
      || (!this.commListGrouped || (this.commListGrouped && this.commListGrouped.length === 0));
  }

  get tableLoading(): boolean {
    return this.isLoading;
  }

  init(): void {
    if (this.checkview) {
      this.commListGrouped = this.checkview.commentaryDate;
      this.commList = this.checkview.commentary;
      this.ready();
    }
  }
}
